import { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { DetailTabs, TabItem } from './DetailTabs'

interface DetailLayoutProps {
  title: string
  subtitle?: string
  avatar?: ReactNode
  backPath: string
  tabs: TabItem[]
  basePath: string
  actions?: ReactNode
  badges?: ReactNode
  children: ReactNode
}

export function DetailLayout({
  title,
  subtitle,
  avatar,
  backPath,
  tabs,
  basePath,
  actions,
  badges,
  children,
}: DetailLayoutProps) {
  const navigate = useNavigate()

  return (
    <div className="space-y-6 animate-slide-in">
      {/* Header */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate(backPath)}
            className="p-2 hover:bg-gray-100 dark:hover:bg-slate-700 rounded-lg transition-colors"
          >
            <ArrowLeft className="h-5 w-5" />
          </button>
          <div className="flex items-center gap-4">
            {avatar}
            <div>
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                {title}
              </h1>
              {subtitle && (
                <p className="text-gray-500 dark:text-gray-400">{subtitle}</p>
              )}
            </div>
          </div>
        </div>
        {actions && (
          <div className="flex items-center gap-2 flex-wrap">
            {actions}
          </div>
        )}
      </div>

      {/* Status badges */}
      {badges && (
        <div className="flex items-center gap-3 flex-wrap">
          {badges}
        </div>
      )}

      {/* Tabs */}
      <DetailTabs tabs={tabs} basePath={basePath} />

      {/* Content */}
      <div className="pt-2">
        {children}
      </div>
    </div>
  )
}
